// JS
import React from 'react';

// IMG
import * as img from './imgData';

// UTILS
import { renderHTMLspan } from './utils';

export const whatIsTheSizeItem = () => [
  {
    item1: {
      uk: '1',
      us: '2',
      eu: '35'
    },
    item2: {
      uk: '2',
      us: '3',
      eu: '36'
    },
    item3: {
      uk: '3',
      us: '4',
      eu: '37'
    },
    item4: {
      uk: '4',
      us: '5',
      eu: '38'
    },
    item5: {
      uk: '5',
      us: '6',
      eu: '39'
    },
    item6: {
      uk: '6',
      us: '7',
      eu: '40'
    },
    item7: {
      uk: '7',
      us: '8',
      eu: '41'
    },
    item8: {
      uk: '8',
      us: '9',
      eu: '42'
    },
    item9: {
      uk: '9',
      us: '10',
      eu: '43'
    },
    item10: {
      uk: '10',
      us: '11',
      eu: '44'
    },
    item11: {
      uk: '11',
      us: '12',
      eu: '45'
    },
    item12: {
      uk: '12',
      us: '13',
      eu: '46'
    }
  }
];

export const whatIsTheSizeSelected = (sizeGuideSelect) => {
  return (
    'item' +
    (sizeGuideSelect === '1'
      ? 1
      : sizeGuideSelect === '2'
      ? 2
      : sizeGuideSelect === '3'
      ? 3
      : sizeGuideSelect === '4'
      ? 4
      : sizeGuideSelect === '5'
      ? 5
      : sizeGuideSelect === '6'
      ? 6
      : sizeGuideSelect === '7'
      ? 7
      : sizeGuideSelect === '8'
      ? 8
      : sizeGuideSelect === '9'
      ? 9
      : sizeGuideSelect === '10'
      ? 10
      : sizeGuideSelect === '11'
      ? 11
      : sizeGuideSelect === '12' && 12)
  );
};

// ARRAY
export const prodCat = [
  'AM_SHIRTS',
  'AM_OVERSHIRT',
  'AM_GILETS',
  'AM_HOODS',
  'AM_SWEATS',
  'AM_KNITWEAR',
  'AM_JACKETS',
  'AM_LIGHTWEIGHT',
  'AM_TEES',
  'AM_LONGTEE',
  'AM_SHORTS',
  'AM_CASUAL',
  'AM_TRACKPANTS',
  'AM_SWEATPANTS',
  'CM_WALLETS',
  'CM_BAGS'
];

const prodCatTop = [
  'AM_SHIRTS',
  'AM_OVERSHIRT',
  'AM_GILETS',
  'AM_HOODS',
  'AM_SWEATS',
  'AM_KNITWEAR',
  'AM_JACKETS',
  'AM_LIGHTWEIGHT',
  'AM_TEES',
  'AM_LONGTEE'
];

const prodCatBottom = [
  'AM_SHORTS',
  'AM_CASUAL',
  'AM_TRACKPANTS',
  'AM_SWEATPANTS'
];

const prodCatAcc = ['CM_WALLETS', 'CM_BAGS'];

// FUNCTIONS
const cmInches = (cm) => {
  return cm ? 'cm' : 'in.';
};

const cmInchesDataAvailable = (item, cm) => {
  return item.cent && item.inches
    ? cm
      ? item.cent + cmInches(cm)
      : item.inches + cmInches(cm)
    : 'n/a ';
};

const productCategory = (data) => {
  return data.product.attributes.defaultcategory[0];
};

const productCategorySleeve = (data) => {
  return data.product.attributes.sleevelength[0];
};

const productCategoryIncludes = (data) => {
  return prodCatTop.some((el) => productCategory(data).includes(el))
    ? 0
    : prodCatBottom.some((el) => productCategory(data).includes(el))
    ? 1
    : prodCatAcc.some((el) => productCategory(data).includes(el)) && 2;
};

const productCategoryImage = (data) => {
  //TOPS
  return productCategory(data) === 'AM_SHIRTS' ||
    productCategory(data) === 'AM_OVERSHIRT'
    ? [img.shirtSVG, 'arm-shirt', 'back-shirt', 'pit-shirt', 'shoulder-shirt']
    : productCategory(data) === 'AM_GILETS'
    ? [img.giletSVG, 'arm-gilet', 'back-gilet', 'pit-gilet', 'shoulder-gilet']
    : productCategory(data) === 'AM_HOODS'
    ? [img.hoodySVG, 'arm-hood', 'back-hood', 'pit-hood', 'shoulder-hood']
    : productCategory(data) === 'AM_SWEATS' ||
      productCategory(data) === 'AM_KNITWEAR'
    ? [
        img.sweatshirtSVG,
        'arm-sweat',
        'back-sweat',
        'pit-sweat',
        'shoulder-sweat'
      ]
    : productCategory(data) === 'AM_JACKETS' ||
      productCategory(data) === 'AM_LIGHTWEIGHT'
    ? [
        img.jacketSVG,
        'arm-jacket',
        'back-jacket',
        'pit-jacket',
        'shoulder-jacket'
      ]
    : productCategory(data) === 'AM_TEES'
    ? [img.tshirtSVG, 'arm-tee', 'back-tee', 'pit-tee', 'shoulder-tee']
    : productCategory(data) === 'AM_LONGTEE'
    ? [
        img.tshirtLongSVG,
        'arm-long-tee',
        'back-long-tee',
        'pit-long-tee',
        'shoulder-long-tee'
      ]
    : // BOTTOMS
    productCategory(data) === 'AM_SHORTS'
    ? [
        img.shortSVG,
        'waist-short',
        'ankle-short',
        'inside-leg-short',
        'rise-short',
        'thigh-short'
      ]
    : productCategory(data) === 'AM_CASUAL' ||
      productCategory(data) === 'AM_TRACKPANTS' ||
      productCategory(data) === 'AM_SWEATPANTS'
    ? [
        img.pantSVG,
        'waist-pant',
        'ankle-pant',
        'inside-leg-pant',
        'rise-pant',
        'thigh-pant'
      ]
    : // ACCESSORIES
    productCategory(data) === 'CM_WALLETS'
    ? [img.walletSVG, 'height-wallet', 'width-wallet', 'depth-wallet']
    : productCategory(data) === 'CM_BAGS' && [
        img.backpackSVG,
        'height-bag',
        'width-bag',
        'depth-bag'
      ];
};

const size = (productSize) => {
  return productSize === 0
    ? 0
    : productSize === 1
    ? 1
    : productSize === 2
    ? 2
    : productSize === 3
    ? 3
    : productSize === 4
    ? 4
    : productSize === 5
    ? 5
    : productSize === 6
    ? 6
    : productSize === 7
    ? 7
    : productSize === 8
    ? 8
    : productSize === 9
    ? 9
    : productSize === 10
    ? 10
    : productSize === 11
    ? 11
    : productSize === 12 && 12;
};

const cmInchesAttributes = (data, productSize) => {
  return data.product.options[size(productSize)].attributes;
};

const cmInchesArray = (data, productSize) => [
  [
    // TOPS
    {
      part:
        (productCategory(data).includes('AM_TEES') &&
          (productCategorySleeve(data).includes('Short Sleeved') ||
            productCategorySleeve(data).includes('Long Sleeved'))) ||
        productCategory(data).includes('AM_GILETS')
          ? 'Remove'
          : 'Arm',
      cent: cmInchesAttributes(data, productSize)?.armcm,
      inches: cmInchesAttributes(data, productSize)?.arminches
    },
    {
      part: 'Back',
      cent: cmInchesAttributes(data, productSize)?.backcm,
      inches: cmInchesAttributes(data, productSize)?.backinches
    },
    {
      part: 'Pit to Pit',
      cent:
        cmInchesAttributes(data, productSize)?.pittopitcm ||
        cmInchesAttributes(data, productSize)?.pittopitcm13,
      inches: cmInchesAttributes(data, productSize)?.pittopitinches
    },
    {
      part: 'Shoulder',
      cent: cmInchesAttributes(data, productSize)?.shouldercm,
      inches: cmInchesAttributes(data, productSize)?.shoulderinches
    }
  ],
  [
    // BOTTOMS
    {
      part: 'Waist',
      cent: cmInchesAttributes(data, productSize)?.waistcm,
      inches: cmInchesAttributes(data, productSize)?.waistinches
    },
    {
      part: productCategory(data).includes('AM_SHORTS') ? 'Remove' : 'Ankle',
      cent: cmInchesAttributes(data, productSize)?.anklecm,
      inches: cmInchesAttributes(data, productSize)?.ankleinches
    },
    {
      part: 'Inside Leg',
      cent: cmInchesAttributes(data, productSize)?.insidelegcm,
      inches: cmInchesAttributes(data, productSize)?.insideleginches
    },
    {
      part: 'Rise',
      cent: cmInchesAttributes(data, productSize)?.risecm,
      inches: cmInchesAttributes(data, productSize)?.riseinches
    },
    {
      part: 'Thigh',
      cent: cmInchesAttributes(data, productSize)?.thighcm,
      inches: cmInchesAttributes(data, productSize)?.thighinches
    }
  ],
  [
    // ACCESSORIES
    {
      part: 'Height',
      cent: cmInchesAttributes(data, productSize)?.heightcm,
      inches: cmInchesAttributes(data, productSize)?.heightinches
    },
    {
      part: 'Width',
      cent: cmInchesAttributes(data, productSize)?.widthcm,
      inches: cmInchesAttributes(data, productSize)?.widthinches
    },
    {
      part: 'Depth',
      cent: cmInchesAttributes(data, productSize)?.depthcm,
      inches: cmInchesAttributes(data, productSize)?.depthinches
    }
  ]
];

const cmInchesHeading = (data, productSize) => {
  return cmInchesArray(data, productSize)[productCategoryIncludes(data)].map(
    (item, index) =>
      item.part !== 'Remove' && (
        <div key={'part[' + index + ']'} className="part">
          {item.part}
        </div>
      )
  );
};

const cmInchesTable = (data, productSize, cm) => {
  return cmInchesArray(data, productSize)[productCategoryIncludes(data)].map(
    (item, index) =>
      item.part !== 'Remove' && (
        <ul key={'size-guide-pim-chart-data[' + index + ']'}>
          <li>{cmInchesDataAvailable(item, cm)}</li>
        </ul>
      )
  );
};

// SIZE GUIDE - PRODUCT SKETCH DATA
const productSketchData = (data, productSize, cm) => {
  return cmInchesArray(data, productSize)[productCategoryIncludes(data)].map(
    (item, index) => (
      <div
        key={'size-guide-pim-image-data[' + index + ']'}
        className={`size-guide-pim-image-data ${
          // TOPS
          item.part === 'Arm'
            ? `${productCategoryImage(data)[1]}`
            : item.part === 'Back'
            ? `${productCategoryImage(data)[2]}`
            : item.part === 'Pit to Pit'
            ? `${productCategoryImage(data)[3]}`
            : item.part === 'Shoulder'
            ? `${productCategoryImage(data)[4]}`
            : // BOTTOMS
            item.part === 'Waist'
            ? `${productCategoryImage(data)[1]}`
            : item.part === 'Ankle'
            ? `${productCategoryImage(data)[2]}`
            : item.part === 'Inside Leg'
            ? `${productCategoryImage(data)[3]}`
            : item.part === 'Rise'
            ? `${productCategoryImage(data)[4]}`
            : item.part === 'Thigh'
            ? `${productCategoryImage(data)[5]}`
            : // ACCESSORIES
            item.part === 'Height'
            ? `${productCategoryImage(data)[1]}`
            : item.part === 'Width'
            ? `${productCategoryImage(data)[2]}`
            : item.part === 'Depth'
            ? `${productCategoryImage(data)[3]}`
            : item.part === 'Remove' && `${'hidden'}`
        }`}
      >
        {item.part}
        <span>{cmInchesDataAvailable(item, cm)}</span>
      </div>
    )
  );
};

// SIZE GUIDE - TABLE DATA
export const ProductSizesTable = ({ data, productSize, cm }) => {
  return (
    <div className="size-guide-pim-table">
      <div className="size-guide-pim-table-heading">
        {cmInchesHeading(data, productSize)}
      </div>
      <div
        key={'size-guide-pim-chart[' + 1 + ']'}
        className="size-guide-pim-chart"
      >
        <div className="size-guide-pim-chart-data">
          {cmInchesTable(data, productSize, cm)}
        </div>
      </div>
    </div>
  );
};

// SIZE GUIDE - PRODUCT SKETCH DATA
export const ProductSizesPopupImage = ({
  data,
  sizeGuideSelect,
  cm,
  productSize
}) => {
  return (
    <div className="size-guide-pim-image">
      <div className="size-guide-pim-image-size">
        Size : <span>{sizeGuideSelect}</span>
      </div>
      {productSketchData(data, productSize, cm)}
      {renderHTMLspan(
        productCategoryImage(data)[0],
        `size-guide-pim-image-svg ${
          (prodCatBottom.some((el) => productCategory(data).includes(el)) ||
            prodCatAcc.some((el) => productCategory(data).includes(el))) &&
          'mb-[15px]'
        }`
      )}
    </div>
  );
};
